module.exports = __webpack_public_path__ + "img/karriere-v3.152b4ced.jpg";